import { Navigate, useLocation } from 'react-router-dom';

/** Redirect legacy `/org/{module}…` URLs to `/{module}…` preserving suffix, query, and hash. */
export function LegacyModulePathRedirect({ fromPrefix, toPrefix }: { fromPrefix: string; toPrefix: string }) {
  const location = useLocation();
  const suffix = location.pathname.slice(fromPrefix.length);
  const target = `${toPrefix}${suffix}${location.search}${location.hash}`;
  return <Navigate to={target} replace />;
}
